import React from "react";
import { Box, Grid } from "@mui/material";

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const ACTIVITY_CONFIG = [
  { key: "preGermination", label: "Pre-Germination", color: "blue" },
  { key: "directSowing", label: "Direct Sowing", color: "#ffa726" },
  { key: "setting", label: "Setting", color: "#8d6e63" },
  { key: "planting", label: "Planting", color: "green" },
  { key: "pruning", label: "Pruning", color: "#9c27b0" },
  { key: "harvest", label: "Harvesting", color: "orange" },
  { key: "picking", label: "Picking", color: "#4caf50" },
];

const inInterval = (monthIndex, start, end) =>
  start !== null &&
  end !== null &&
  ((start <= end && monthIndex >= start && monthIndex <= end) ||
    (start > end && (monthIndex >= start || monthIndex <= end)));

const monthInAnyInterval = (monthIndex, intervals) =>
  (intervals || []).some((i) => inInterval(monthIndex, i.start, i.end));

const MonthBoxGrid = ({ ranges }) => {
  return (
    <Grid container spacing={0.5} wrap="nowrap">
      {monthNames.map((month, index) => {
        const activities = ACTIVITY_CONFIG.filter((a) =>
          monthInAnyInterval(index, ranges[a.key])
        ).map((a) => a.label);

        const colors = ACTIVITY_CONFIG.filter((a) =>
          monthInAnyInterval(index, ranges[a.key])
        ).map((a) => a.color);

        let style = {};
        if (colors.length === 1) {
          style.backgroundColor = colors[0];
        } else if (colors.length > 1) {
          style.background = `linear-gradient(45deg, ${colors.join(", ")})`;
        } else {
          style.backgroundColor = "lightgray";
        }

        const hoverText = activities.length > 0 ? activities.join(", ") : "No activity";

        return (
          <Box
            key={index}
            className="month-box"
            style={style}
            title={`${month} - ${hoverText}`}
          />
        );
      })}
    </Grid>
  );
};

export default MonthBoxGrid;
